/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { err, ok } from "../data/file-system/utils.js";
export { FileSystemHandlerFactory };
class FileSystemHandlerFactory {
    fs;
    constructor(fs) {
        this.fs = fs;
    }
    query() {
        return async (inputs) => {
            if (!this.fs) {
                return err("File system capability is not available");
            }
            return this.fs.query(inputs);
        };
    }
    read() {
        return async (inputs) => {
            if (!this.fs) {
                return err("File system capability is not available");
            }
            return this.fs.read(inputs);
        };
    }
    write() {
        return async (inputs) => {
            if (!this.fs) {
                return err("File system capability is not available");
            }
            const result = await this.fs.write(inputs);
            if (!ok(result)) {
                return result;
            }
            return {};
        };
    }
}
//# sourceMappingURL=file-system-handler-factory.js.map